import classnames from 'classnames';
import { map } from 'ramda';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Tooltip } from '@wix/design-system';
import { LassoItem } from '../../../../../../components/common/Lasso/LassoItem';
import { MediaManagerSDKFolder } from '../../../../../../utils/media-manager-sdk';
import { isFile } from '../../../../../../utils/media-manager-sdk/items';
import styles from './FilesGallery.scss';
import { IOuter } from './FilesGallery.types';
import { ReadonlyFile } from './ReadonlyFile';
import { ReadonlyFolder } from './ReadonlyFolder';

export const FilesGallery: FC<IOuter> = ({
  items,
  isItemSelected,
  isItemDisabled,
  onFileDoubleClick,
  onFolderDoubleClick,
  clearItemsSelection,
  onItemClick,
  isFilesImporterNewLayout,
}) => (
  <div className={classnames(styles.wrapper, { [styles.wrapperNewLayout]: true })} onMouseDown={clearItemsSelection}>
    {map(
      (item) => (
        <div className={classnames(styles.itemWrapper, { [styles.itemWrapperNewLayout]: true })} key={item.id}>
          <LassoItem itemId={item.id}>
            {isFile(item) ? (
              isItemDisabled(item) ? (
                <Tooltip content={<FormattedMessage id="files-importer.purchased-file.prohibit-share.tooltip" />}>
                  <ReadonlyFile
                    item={item}
                    onClick={onItemClick}
                    onDoubleClick={onFileDoubleClick}
                    isSelected={isItemSelected(item.id)}
                    isDisabled={true}
                  />
                </Tooltip>
              ) : (
                <ReadonlyFile
                  item={item}
                  onClick={onItemClick}
                  onDoubleClick={onFileDoubleClick}
                  isSelected={isItemSelected(item.id)}
                  isDisabled={false}
                />
              )
            ) : (
              <ReadonlyFolder
                item={item as MediaManagerSDKFolder}
                onClick={onItemClick}
                onDoubleClick={onFolderDoubleClick}
                isSelected={isItemSelected(item.id)}
                isFilesImporterNewLayout={isFilesImporterNewLayout}
              />
            )}
          </LassoItem>
        </div>
      ),
      items,
    )}
  </div>
);
